import { Countdown } from 'components/countdown';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import {
  getTaskCycles,
  getPlayerInfo,
  getTasks,
  getTasksManager,
  getVacationManager,
  getServerTime,
  getTasksPendingApprovalParticipants,
  getTotalTasks,
} from 'services/dashboard.service';
import { GetTaskLevelLabel, GetTaskStatusLabel } from 'utils/strings';

import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import { User, VacationManagerInterface } from 'types/user';
import VacationManagerModal from 'components/vacation-manager-modal';
import { useModal } from 'context/ModalContext';
import { getStorageItem, removeStorageItem, setStorageItem } from 'utils/storage';
import { AiOutlineWarning } from 'react-icons/ai';
import Tippy from '@tippyjs/react';
import { BiInfoCircle } from 'react-icons/bi';
import { findLateralMenagers } from 'services/profile.service';
import SearchGestor from 'pages/MinhaEquipe/components/SearchGestor';
import { UserNeedingApprovalModal } from 'components/user-needing-approval-modal';
import { TasksPendingApprovalParticipantsModal } from 'components/tasks-pending-approval-participants-modal';
import { LuBell } from 'react-icons/lu';
import { getTaskStep } from 'utils/helpers';

interface Props {
  taskManager: any[];
}

export function TaskCycles({ taskManager }: Props) {
  const navigate = useNavigate();
  const { user, userInfo, cycles, currentCycle } = useAuth();
  const { showModal, closeModal } = useModal();
  const [canRegister, setCanRegister] = useState(true);
  const [predefinedAgreementType, setPredefinedAgreementType] = useState<boolean | undefined>();

  // const [tasks, setTasks] = useState<any>();
  const [currentTaskCycle, setCurrentTaskCycle] = useState<any>();
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [taskCycles, setTaskCycles] = useState<any>();
  const [myTasks, setMyTasks] = useState<any[]>();
  const [totalTask, setTotalTask] = useState<any>();
  const [participationTasks, setParticipationTasks] = useState<any[]>();
  const [vacationManagers, setVacationManagers] = useState<VacationManagerInterface[]>();
  const [evaluateTasks, setEvaluateTasks] = useState<any[]>();
  const [playerInfo, setPlayerInfo] = useState<any>();
  const [cycleActive, setCycleActive] = useState<string>();
  const [evaluateCycleActive, setEvaluateCycleActive] = useState<string>();
  const [lateralManagers, setLateralManagers] = useState<User[]>();
  const [showModalLateral, setShowModalLateral] = useState(false);
  const [isExperied, setIsExperied] = useState(false);
  const [isStarting, setIsStarting] = useState(false);
  const [loadingLateralManagers, setLoadingLateralManagers] = useState(false);

  const [tasksPendingApproval, setTasksPendingApproval] = useState<any[]>();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const activeCycleObj = useMemo(() => taskCycles?.find((item: any) => item._id === cycleActive), [cycleActive, taskCycles]);

  const evaluateActiveCycleObj = useMemo(
    () => taskCycles?.find((item: any) => item._id === evaluateCycleActive),
    [evaluateCycleActive, taskCycles],
  );

  const taskPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !taskCycles?.length || !cycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === cycleActive);

    let _task = myTasks;

    if (
      (!myTasks || !myTasks?.length || myTasks?.length < 1) &&
      participationTasks &&
      participationTasks?.length &&
      participationTasks?.length > 0
    ) {
      _task = participationTasks;
    }

    const tasks = _task.filter(
      item => item.created >= cycle.date_start && item.created <= cycle.date_finish && item.status !== 'arquivado',
    );

    return tasks?.length ? tasks[0] : null;
  }, [cycleActive, myTasks, participationTasks, taskCycles]);

  const canViewTabEquipe = useMemo(
    () =>
      !!playerInfo?.ro.match(/(3GUE|2GUT|2GCA|2GUA)/gi) ||
      !!playerInfo?.ro.match(/(2GUE|1GUT|1GUA|1GCA)/gi) ||
      playerInfo?.cod_funcao === 3002 ||
      playerInfo?.cod_funcao === 3003 ||
      playerInfo?.cod_funcao === 4005 ||
      playerInfo?.cod_funcao === 4007,
    [playerInfo],
  );

  // const isCurrentEvaluator = useCallback(
  //   (item: any) => {
  //     if (!user || !item || !playerInfo) return false;

  //     if (item.evaluator?.length) {
  //       const matriculaEvaluator = parseInt(
  //         item.evaluator[item.evaluator.length - 1].replace('F', '')
  //       );
  //       const currentId = parseInt(user.extra.id);

  //       return matriculaEvaluator === currentId;
  //     } else {
  //       return playerInfo.cod_etapa && playerInfo.cod_etapa > 0;
  //     }
  //   },
  //   [playerInfo, user]
  // );

  const evaluateTaskPerCycle: any = useMemo(() => {
    if (!Array.isArray(evaluateTasks) || !taskCycles?.length || !evaluateCycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks = evaluateTasks.filter(item => item.created >= cycle.date_start && item.created <= cycle.date_finish);

    return tasks?.length ? tasks[tasks.length - 1] : null;

    // let tasksFiltered = tasks.filter((item: any) => !!isCurrentEvaluator(item));

    // if (tasksFiltered?.length) {
    //   tasksFiltered = tasksFiltered[tasksFiltered.length - 1];
    // } else {
    //   tasksFiltered = tasks[tasks.length - 1];
    // }

    // console.log(tasksFiltered);

    // return !!tasksFiltered ? tasksFiltered : null;
  }, [evaluateCycleActive, evaluateTasks, taskCycles]);

  const getActiveEvaluationStep: (0 | 2 | 3 | 4 | 4.1 | 5)[] | null = useMemo((): (0 | 2 | 3 | 4 | 4.1 | 5)[] | null => {
    if (!evaluateActiveCycleObj || !realDatetime) return null;

    if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step2_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step2_finish
    ) {
      // Etapa 2
      return [2, 3];
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step4_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step4_finish
    ) {
      // Etapa 3
      return [4, 4.1];
    } else if (
      realDatetime > evaluateActiveCycleObj.date_evaluation_step5_start &&
      realDatetime < evaluateActiveCycleObj.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return [5];
    } else {
      return [0];
    }
  }, [evaluateActiveCycleObj, realDatetime]);

  const getPlayerStep = (task: any) => {
    if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) {
      return 4.1;
    }

    if (typeof playerInfo.cod_etapa === 'number') {
      if (playerInfo.cod_etapa === 2) {
        return 2;
      }

      if (playerInfo.cod_etapa === 4) {
        return 4;
      }

      if (playerInfo.cod_etapa === 5) {
        return 5;
      }

      if (playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3) {
        if (String(task.original_manager) === String(playerInfo._id)) {
          if (task.status === 'rejeitado' || task.status === 'aguardando') {
            return 2;
          } else {
            return 3;
          }
        } else {
          return 3;
        }
      }

      return 0;
    }

    return 0;
  };

  const htmlCountdownEvaluation = useMemo(() => {
    if (
      !evaluateActiveCycleObj ||
      (!getActiveEvaluationStep && getActiveEvaluationStep !== 0) ||
      !playerInfo ||
      !Array.isArray(evaluateTasks) ||
      !taskCycles?.length ||
      !evaluateCycleActive
    ) {
      setIsExperied(true);

      return <></>;
    }

    const cycle = taskCycles.find((cycle: any) => cycle._id === evaluateCycleActive);

    const tasks: any[] = evaluateTasks.filter(task => task.created >= cycle.date_start && task.created <= cycle.date_finish);
    if (evaluateActiveCycleObj.status === 'open') {
      setIsExperied(false);
      return (
        <span className="text-white font-thin">
          O período de avaliação desta fase inicia em:{' '}
          <strong className="font-semibold whitespace-nowrap">
            <Countdown key="missao" deadline={new Date(evaluateActiveCycleObj.date_finish)} />
          </strong>
        </span>
      );
    } else if (evaluateActiveCycleObj.status === 'evaluation') {
      if (tasks.length) {
        const userTaskStep: number[] = tasks
          .map(task => (typeof getPlayerStep(task) === 'number' ? (getPlayerStep(task) as number) : 0))
          .sort(() => -1);

        const isStepIncluded = getActiveEvaluationStep
          ? getActiveEvaluationStep.some(step => userTaskStep.includes(step))
          : false;

        if (isStepIncluded) {
          const date_finish = getActiveEvaluationStep.includes(2)
            ? evaluateActiveCycleObj?.date_evaluation_step2_finish
            : getActiveEvaluationStep.includes(3)
              ? evaluateActiveCycleObj?.date_evaluation_step4_finish
              : getActiveEvaluationStep.includes(4)
                ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                : getActiveEvaluationStep.includes(4.1)
                  ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                  : evaluateActiveCycleObj?.date_evaluation_step5_finish;

          setIsExperied(false);

          return (
            <span className="text-white font-thin">
              O período de apreciação deste nível termina em:{' '}
              <strong className="font-semibold whitespace-nowrap">
                <Countdown key="missao" deadline={new Date(date_finish)} />
              </strong>
            </span>
          );
        } else {
          const hasAfter = getActiveEvaluationStep
            ? userTaskStep?.find(x => getActiveEvaluationStep.some(step => x > step))
            : undefined;

          const date_start =
            hasAfter === 2
              ? evaluateActiveCycleObj?.date_evaluation_step2_start
              : hasAfter === 3
                ? evaluateActiveCycleObj?.date_evaluation_step4_start
                : hasAfter === 4
                  ? evaluateActiveCycleObj?.date_evaluation_step4_start
                  : hasAfter === 4.1
                    ? evaluateActiveCycleObj?.date_evaluation_step4_start
                    : evaluateActiveCycleObj?.date_evaluation_step5_start;

          if (!!hasAfter) {
            setIsExperied(false);
            setIsStarting(true);
            return (
              <span className="text-white font-thin">
                O período de apreciação começa em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_start)} />
                </strong>
              </span>
            );
          } else {
            setIsExperied(true);
            return <></>;
          }
        }
      } else {
        const codEtapa =
          playerInfo.cod_etapa === 2
            ? 2
            : playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3
              ? 3
              : playerInfo.cod_etapa === 4
                ? 4
                : playerInfo.cod_etapa === 5
                  ? 5
                  : null;

        if (codEtapa) {
          if (getActiveEvaluationStep.includes(codEtapa)) {
            const date_finish = getActiveEvaluationStep.includes(2)
              ? evaluateActiveCycleObj?.date_evaluation_step2_finish
              : getActiveEvaluationStep.includes(3)
                ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                : getActiveEvaluationStep.includes(4)
                  ? evaluateActiveCycleObj?.date_evaluation_step4_finish
                  : evaluateActiveCycleObj?.date_evaluation_step5_finish;

            setIsExperied(false);
            return (
              <span className="text-white font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="font-semibold whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </span>
            );
          } else {
            if (getActiveEvaluationStep?.some(step => step < codEtapa)) {
              const date_start =
                codEtapa === 2
                  ? evaluateActiveCycleObj?.date_evaluation_step2_start
                  : codEtapa === 3
                    ? evaluateActiveCycleObj?.date_evaluation_step4_start
                    : codEtapa === 4
                      ? evaluateActiveCycleObj?.date_evaluation_step4_start
                      : evaluateActiveCycleObj?.date_evaluation_step4_start;
              setIsExperied(false);
              setIsStarting(true);
              return (
                <span className="text-white font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="font-semibold whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </span>
              );
            } else {
              setIsExperied(true);
              return <></>;
            }
          }
        } else {
          setIsExperied(true);
          return <></>;
        }
      }
    } else {
      setIsExperied(true);
      return <></>;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateActiveCycleObj, evaluateCycleActive, evaluateTasks, getActiveEvaluationStep, playerInfo, taskCycles]);

  const hasToEvaluate = useMemo(() => {
    if (!Array.isArray(evaluateTasks)) {
      return false;
    }

    const tasks = evaluateTasks.filter((item: any) => {
      const lastManager = item?.evaluator?.length ? item.evaluator[item.evaluator.length - 1] : item.original_manager;
      const taskStep = getTaskStep(item);

      if (lastManager !== playerInfo?._id) {
        return false;
      }

      // if (getActiveEvaluationStep?.includes(2) && lastManager === playerInfo?._id && item.status !== 'aguardando') {
      //   return false;
      // }

      if (item.status === 'concluidoAuto' || item.status === 'concluido' || item.status === 'selo') {
        return false;
      }

      // if (
      //   getActiveEvaluationStep?.some(step => step > 2) && // Verifica se algum valor é maior que 2
      //   lastManager === playerInfo?._id &&
      //   (item.status === 'concluidoAuto' || item.status === 'concluido' || item.status === 'selo')
      // ) {
      //   return false;
      // }

      if (taskStep && !getActiveEvaluationStep?.includes(taskStep)) {
        return false;
      }

      return true;
    });

    return tasks.length > 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateTasks, getActiveEvaluationStep, playerInfo]);

  const showHasEvaluated = useMemo(() => {
    if (!isExperied && !hasToEvaluate && !isStarting) {
      return true;
    }

    // if (!hasToEvaluate && getActiveEvaluationStep?.includes(2)) {
    //   return true;
    // }

    return false;
  }, [hasToEvaluate, isExperied, isStarting]);

  useEffect(() => {
    async function getUserInfo() {
      try {
        const _playerInfo: any = userInfo;

        if (_playerInfo) {
          if (
            !!_playerInfo?.ro.match(/(3GUE|2GUT|2GCA|2GUA)/gi) ||
            !!_playerInfo?.ro.match(/(2GUE|1GUT|1GUA|1GCA)/gi) ||
            _playerInfo?.cod_funcao === 3002 ||
            _playerInfo?.cod_funcao === 3003 ||
            _playerInfo?.cod_funcao === 4005 ||
            _playerInfo?.cod_funcao === 4007
          ) {
            const tasksPending = await getTasksPendingApprovalParticipants();
            setTasksPendingApproval(tasksPending);
          }

          setPlayerInfo(_playerInfo);

          const playerCadMissao = _playerInfo.cad_missao && _playerInfo.cad_missao > 0 && !_playerInfo?.mad_dupla;
          // const playerTipoDeAcordo =
          //   !_playerInfo.tipo_de_acordo ||
          //   (typeof _playerInfo?.tipo_de_acordo === 'string' &&
          //     !!_playerInfo?.tipo_de_acordo &&
          //     !!_playerInfo?.tipo_de_acordo?.match(/HIBRIDO/gi));

          // setPredefinedAgreementType(
          //   typeof _playerInfo.cad_missao &&
          //     _playerInfo.cad_missao > 0 &&
          //     typeof _playerInfo?.tipo_de_acordo === 'string' &&
          //     !!_playerInfo?.tipo_de_acordo &&
          //     !!_playerInfo?.tipo_de_acordo?.match(/PREDEFINIDO/gi),
          // );
          setPredefinedAgreementType(false);
          // setCanRegister(playerCadMissao && playerTipoDeAcordo);
          setCanRegister(playerCadMissao);

          const taskCycleResults = await getTaskCycles();
          setTaskCycles(taskCycleResults);

          // Pode cadastrar
          if (playerCadMissao) {
            const data = await getTasks(user?._id);

            const my_tasks = data.filter((item: any) => item.owner === user?._id);
            const other_tasks = data.filter((item: any) => item.owner !== user?._id);

            setMyTasks(my_tasks);
            setParticipationTasks(other_tasks);

            const currentCycle = taskCycleResults.find((item: any) => item.status === 'open');

            setCycleActive(currentCycle?._id || taskCycleResults[0]._id);

            // const _totalTask = await getTotalTasks();
            // setTotalTask(_totalTask);
          }
        }

        setLoadingTasks(false);
      } catch (e) {
        console.log(e);
      }
    }

    if (user && !playerInfo && Array.isArray(taskManager) && !!realDatetime) {
      getUserInfo();
    }
  }, [canViewTabEquipe, playerInfo, taskManager, user, userInfo, realDatetime]);

  useEffect(() => {
    async function getUserInfo() {
      const _playerInfo: any = userInfo;

      // Gestor
      if (
        (_playerInfo.cod_etapa && _playerInfo.cod_etapa > 0 && _playerInfo.cod_etapa <= 5) ||
        (typeof _playerInfo?.mad_dupla_cod_etapa === 'number' &&
          _playerInfo?.mad_dupla_cod_etapa > 0 &&
          _playerInfo?.mad_dupla_cod_etapa <= 5)
      ) {
        const currentCycle = taskCycles.find((item: any) => item.status === 'evaluation');
        const cycleId = currentCycle?._id || taskCycles[0]._id;

        const evaluateStage = taskCycles?.find((item: any) => item._id === cycleId);

        const isSemetral = evaluateStage && !!getActiveEvaluationStep?.includes(5);

        const isTrimestral = evaluateStage && !!getActiveEvaluationStep?.includes(4);

        if (evaluateStage) {
          const start = isSemetral
            ? evaluateStage.cycle.date_start
            : isTrimestral
              ? evaluateStage.date_trimester_start
              : evaluateStage.date_start;
          const end = isSemetral
            ? evaluateStage.cycle.date_end
            : isTrimestral
              ? evaluateStage.date_trimester_finish
              : evaluateStage.date_finish;

          const data = taskManager?.filter((e: any) => start && end && e.created >= start && e.created <= end);

          setEvaluateTasks(data);
        }
        setEvaluateCycleActive(cycleId);

        if (
          !loadingLateralManagers &&
          !Array.isArray(lateralManagers) &&
          !!currentCycle &&
          currentCycle.status === 'evaluation'
        ) {
          setLoadingLateralManagers(true);
          const managers = await findLateralMenagers();
          setLateralManagers(managers || []);
          setLoadingLateralManagers(false);
        }
      }
    }

    if (Array.isArray(taskManager) && taskCycles && userInfo) {
      getUserInfo();
    }
  }, [getActiveEvaluationStep, lateralManagers, loadingLateralManagers, taskCycles, taskManager, userInfo]);

  useEffect(() => {
    const storedItem = getStorageItem('participant_notifications_read');

    if (Array.isArray(tasksPendingApproval) && tasksPendingApproval.length) {
      let _showModal = false;

      if (Array.isArray(storedItem) && storedItem.length) {
        tasksPendingApproval.forEach(x => {
          if (!storedItem.find(y => y === x._id)) {
            _showModal = true;
          }
        });
      } else {
        _showModal = true;
      }

      if (_showModal) {
        showModal('tasks-pending-approval-participants-modal');
      }
    }
  }, [showModal, tasksPendingApproval]);

  useEffect(() => {
    removeStorageItem('manager_lateralidade');
  }, []);

  function getDescription() {
    return (
      <p>
        Você possui acordo individual do tipo pré-definido na Plataforma Conexão e por isso, não realiza o cadastramento, mas pode
        participar de ações de outras equipes, participando da premiação coletiva. <br />
        <br />
        Para premiação individual a pontuação final das Realizações Destaque será pelo Placar Consolidado da Plataforma Conexão.
      </p>
    );
  }

  return (
    <>
      <div className="flex flex-col">
        {!loadingTasks ? (
          <>
            <div className="space-y-6 flex flex-col w-full">
              {/* {!!taskPerCycle || !!evaluateTaskPerCycle ? (
                <>
                  <div className="text-white font-normal text-xl lg:text-2xl leading-none -mb-4 text-left">
                    Realizações Destaque
                  </div>
                  <p className="text-white text-xs lg:text-sm block font-thin">
                    Visualize suas Realizações destaque e acompanhe os status de apreciação.
                  </p>
                </>
              ) : null} */}

              {/* Cadastro */}
              {!!canRegister ? (
                <div>
                  {!!taskPerCycle ? (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-9">
                        <div>
                          <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left" tabIndex={0}>
                            Realizações Destaque
                          </h2>

                          <p className="font-thin" tabIndex={0}>
                            Visualize suas Realizações Destaque e acompanhe os status de apreciação.
                          </p>
                        </div>

                        <div aria-hidden={true}>
                          <img src={ImgFeedback} className="max-w-[186px]" alt="" />
                        </div>
                      </div>

                      <>
                        <div className="flex flex-col lg:flex-row items-center justify-center space-y-3 lg:space-y-0 lg:space-x-6">
                          <button
                            className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-10`}
                            onClick={() => navigate('/realizacao-destaque')}
                            aria-label="Acompanhar minhas realizações destaque"
                          >
                            Acompanhar realizações
                          </button>
                        </div>
                      </>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-9">
                        <div>
                          <h2 className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left" tabIndex={0}>
                            Realizações Destaque
                          </h2>

                          <p className="font-thin" tabIndex={0}>
                            Visualize suas Realizações Destaque e acompanhe os status de apreciação.
                          </p>
                        </div>

                        <div aria-hidden={true}>
                          <img src={ImgFeedback} className="max-w-[186px]" alt="" />
                        </div>
                      </div>

                      <>
                        <div className="flex flex-col lg:flex-row items-center justify-center space-y-3 lg:space-y-0 lg:space-x-6">
                          <button
                            className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-auto px-3 lg:px-4 h-10`}
                            onClick={() => navigate('/realizacao-destaque')}
                            aria-label="Acompanhar minhas realizações destaque"
                          >
                            Acompanhar realizações
                          </button>
                        </div>
                      </>
                    </>
                  )}
                </div>
              ) : !!predefinedAgreementType ? (
                <>
                  <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-4">
                    <div>
                      <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left">
                        Realizações Destaque
                      </div>

                      <p className="font-thin">Visualize suas Realizações Destaque e acompanhe os status de apreciação.</p>

                      <div className="flex items-center space-x-2 my-3">
                        <AiOutlineWarning className="text-yellow" size={25} />
                        <b>Você possui acordo individual do tipo pré-definido na Plataforma Conexão.</b>
                        <Tippy
                          arrow={true}
                          allowHTML={true}
                          className="bg-black text-white font-thin rounded-xl p-2 tippy"
                          content={getDescription()}
                        >
                          <div>
                            <BiInfoCircle className="color-[#C2D2FF] text-base lg:text-2xl" />
                          </div>
                        </Tippy>
                      </div>
                    </div>

                    <div>
                      <img src={ImgFeedback} className="max-w-[186px]" alt=" " />
                    </div>
                  </div>

                  <button
                    className={`w-auto md:w-[314px] mx-auto text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue bg-slate-blue rounded px-3 lg:px-4 h-10`}
                    onClick={() => navigate('/realizacao-destaque')}
                  >
                    Acompanhar Realizações Destaque
                  </button>
                </>
              ) : null}

              {/* Gestor */}
              {(!!playerInfo?.cod_etapa && playerInfo?.cod_etapa > 0 && playerInfo?.cod_etapa <= 5) ||
              (typeof playerInfo?.mad_dupla_cod_etapa === 'number' &&
                playerInfo?.mad_dupla_cod_etapa > 0 &&
                playerInfo?.mad_dupla_cod_etapa <= 5) ? (
                <div>
                  {!!evaluateTaskPerCycle ? (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-9">
                        <div>
                          <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left">
                            Realizações Destaque
                          </div>
                        </div>

                        <div>
                          <img src={ImgFeedback} className="max-w-[186px]" alt=" " />
                        </div>
                      </div>

                      <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 items-center justify-between md:space-x-4">
                        <button
                          className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/minha-equipe/validar-apreciar-realizacao')}
                        >
                          Acompanhar realizações
                        </button>

                        <button
                          className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/realizacao-destaque')}
                        >
                          Acompanhar MINHAS realizações
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-col md:flex-row md:space-x-16 justify-between space-y-4 lg:space-y-6  rounded-2xl lg:rounded-[20px]  w-full mb-9">
                        <div>
                          <div className="text-white font-normal text-xl lg:text-2xl leading-none mb-2 text-left">
                            Realizações Destaque
                          </div>
                        </div>

                        <div>
                          <img src={ImgFeedback} className="max-w-[186px]" alt=" " />
                        </div>
                      </div>

                      <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 items-center justify-between md:space-x-4">
                        <button
                          className={`text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-normal lg:font-semibold uppercase ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/minha-equipe/validar-apreciar-realizacao')}
                        >
                          Acompanhar realizações
                        </button>

                        <button
                          className={`text-white text-sm flex items-center justify-center font-normal lg:font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded w-full px-3 lg:px-4 h-11 leading-tight`}
                          onClick={() => navigate('/realizacao-destaque')}
                        >
                          Acompanhar MINHAS realizações
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ) : null}

              {/* {canRegister ? (
                    <></>
                  ) : (
                    <>
                      <p className="text-white text-sm block mb-6 font-thin text-center tracking-tight">
                        <strong className="font-semibold text-base lg:text-lg block mb-4 text-yellow">
                          Sua equipe ainda não cadastrou Realizações Destaque nesta fase
                        </strong>
                      </p>
                    </>
                  )} */}

              {/* <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center mt-8 w-full"> */}
              {/* {taskCycles?.map((item: any) => {
            // const buttonColor =
            //   item.status === "open" ? "secondary" : "outline";
            return (
              <div className="flex items-center space-x-5" key={item._id}>
                <div className="bg-maastricht-blue rounded-md px-5 py-3 text-sm">
                  <p className="font-thin ">
                    <b className="font-normal">Nome da ação:</b> Protótipo para
                    o JogaJuntoBB
                  </p>
                  <p className="font-thin">
                    <b className="font-normal">Status da entrega:</b> Aguardando
                    validação
                  </p>
                </div>

                <Button
                  color="primary"
                  className="uppercase py-2 text-sm"
                  onClick={() => navigate("/realizacao-destaque")}
                >
                  {item.title} - {GetTaskStatusLabel(item.status)}
                </Button>
              </div>
            );
          })} */}

              {/* {!canRegister && (
            <Button color="outline" className="uppercase py-2 bg-yellow" onClick={() => navigate('/realizacao-destaque')}>
              1º Fase - Em validação
            </Button>
          )}

          {!canRegister && !tasks && (
            <Button className="uppercase py-2" onClick={() => navigate('/realizacao-destaque')}>
              2º Fase - cadastrar
            </Button>
          )}

          {!canRegister && !!tasks && (
            <Button
              onClick={() => navigate(`/realizacao-destaque`)}
              color="clear"
              className="uppercase py-2 bg-blue-light text-blue-dark"
            >
              <div className="flex flex-row items-center space-x-2">
                <span>Ver suas entregas</span>
                <BiEdit />
              </div>
            </Button>
          )} */}

              {/* {!!tasks && tasks.status === 'ok' && (
        <div className="py-2 px-3 rounded-full bg-green-700 ring-2 ring-white text-white">
          <div className="">
            <span>Entrega Reconhecida: </span> +{getTaskPoints(tasks)} pontos
          </div>
        </div>
      )} */}

              {/* {canRegister && (
            <Button
              color="clear"
              className="uppercase py-2 bg-yellow text-blue-dark"
              onClick={() => navigate("/minha-equipe/validar-apreciar-realizacao")}
            >
              Avaliar Entregas da Equipe
            </Button>
          )} */}
            </div>
          </>
        ) : (
          <div className="text-center text-lg p-2 px-4 border rounded-full mt-3">Carregando informações...</div>
        )}
      </div>

      {!!lateralManagers?.length && evaluateActiveCycleObj?.status === 'evaluation' && showModalLateral && (
        <SearchGestor
          closeModal={() => setShowModalLateral(false)}
          onSubmit={id => {
            setStorageItem('manager_lateralidade', id._id);
            setShowModalLateral(false);
            navigate('/minha-equipe/validar-apreciar-realizacao');
          }}
        />
      )}

      <TasksPendingApprovalParticipantsModal tasks={tasksPendingApproval} />
    </>
  );
}
